// extracted by mini-css-extract-plugin
export default {"testimonial_section_container":"TestimonialSection_testimonial_section_container__V-Zfe","testimonial_section_header":"TestimonialSection_testimonial_section_header__Cgnlg"};